import { createBrowserRouter, Navigate } from "react-router-dom";

import NotFound from "../pages/not-found";
import Homepage from "../pages/homepage";
import RouteHome from "../pages/apis/route";
import Pricing from "../pages/pricing";
import GeocodeHome from "../pages/apis/geocode";
import PlacesHome from "../pages/apis/places";
// import Building from "../pages/apis/building";
import AddressHome from "../pages/apis/address";
import AddressParsing from "../pages/apis/address/address-parsing";
import AddressValidation from "../pages/apis/address/address-validation";
import Contact from "../pages/contact";
// import Routing from "../pages/apis/route/routing";
// import RoutePlanner from "../pages/apis/route/routeplanner";
import PlacesAutocomplete from "../pages/apis/places/autocomplete";
import PlacesDetail from "../pages/apis/places/detail";
import ReverseGeocode from "../pages/apis/geocode/reverse";
import ForwardGeocode from "../pages/apis/geocode/forward";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Homepage />,
  },
  {
    path: "route",
    children: [
      { index: true, element: <RouteHome /> },
      // {
      //   path: "routing",
      //   element: <Routing />,
      // },
      // {
      //   path: "routeplanner",
      //   element: <RoutePlanner />,
      // },
    ],
  },

  {
    path: "/places",
    children: [
      {
        index: true,
        element: <PlacesHome />,
      },
      {
        path: "detail",
        element: <PlacesDetail />,
      },
      {
        path: "autocomplete",
        element: <PlacesAutocomplete />,
      },
    ],
  },

  {
    path: "/geocode",
    children: [
      {
        index: true,
        element: <GeocodeHome />,
      },
      {
        path: "forward",
        element: <ForwardGeocode />,
      },
      {
        path: "reverse",
        element: <ReverseGeocode />,
      },
    ],
  },

  {
    path: "address",
    children: [
      { index: true, element: <AddressHome /> },
      {
        path: "address-parsing",
        element: <AddressParsing />,
      },
      {
        path: "address-validation",
        element: <AddressValidation />,
      },
    ],
  },

  // {
  //   path: "/building",
  //   element: <Building />,
  // },
  {
    path: "pricing",
    element: <Pricing />,
  },
  {
    path: "contact",
    element: <Contact />,
  },
  {
    path: "404",
    element: <NotFound />,
  },
  {
    path: "*",
    element: <Navigate to="/404" replace={true} />,
  },
]);

export default router;
